enum localStorageKeys {
  filterActiveLaneIds = "filterActiveLaneIds",
  activeHallId = "activeHallId",
}

export const setFilterActiveLaneIds = (laneIds: string[]) => {
  localStorage.setItem(localStorageKeys.filterActiveLaneIds, laneIds.join(","));
};
export const getActiveLanesLocalStorage = () => {
  const laneIds = localStorage.getItem(localStorageKeys.filterActiveLaneIds);
  return laneIds ? laneIds.split(",") : [];
};

export const setActiveHallId = (hallId: string) => {
  localStorage.setItem(localStorageKeys.activeHallId, hallId);
};
export const getActiveHallIdLocalStorage = () => {
  return localStorage.getItem(localStorageKeys.activeHallId) || undefined;
};
